import { render, staticRenderFns } from "./EditionModal.vue?vue&type=template&id=51702d7b&scoped=true&"
import script from "./EditionModal.vue?vue&type=script&lang=js&"
export * from "./EditionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51702d7b",
  null
  
)

export default component.exports